import http from '~/http/cryptomat';

export default ({
  state: {
    data: [],
    filters: {},
    page: 1,
    pages: 0,
    limit: 10,
    itemsPerPage: 0,
  },

  mutations: {
    SET_DATA(state, value) { state.data = value; },
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        filters,
        page,
      } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const formattedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value || value === 0) {
          acc[key] = value;
        }
        return acc;
      }, {});
      return {
        ...formattedFilters,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
    },
  },

  actions: {
    async loadData({ getters, commit }) {
      const response = await http.get('/api/checks', {
        ...getters.requestData,
      });
      const { data } = response;
      // commit('SET_DATA', response.data);
      if (data.pages) {
        commit('SET_PAGES', data.pages);
      }
    },

    async updateCheck(__state, id) {
      await http.put(`/api/checks/update/${id}`);
    },
  },

  namespaced: true,
});
